import React from 'react';

/**
 * SkillsBlock renders categorized skill lists or a flat tag grid.
 * Supports: skills-simple-list, skills-tags, skills-categorized, skills-sidebar, skills-badge-grid.
 */
export const SkillsBlock = ({ items = [], categories = {}, variant = 'skills-simple-list' }) => {
  const hasCategories = Object.keys(categories || {}).length > 0;
  const flatSkills = items.map(skill => typeof skill === 'string' ? skill : (skill.name || skill.title || '')).filter(Boolean);

  // 1. Tags Layout (Rounded capsule tags)
  if (variant === 'skills-tags') {
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px 10px' }}>
        {flatSkills.map((skill, idx) => (
          <span 
            key={idx} 
            style={{ 
              padding: '4px 10px', 
              backgroundColor: 'var(--color-border, #F1F5F9)', 
              borderRadius: '20px',
              fontSize: 'var(--font-size-meta, 8pt)',
              fontWeight: 'var(--weight-label, 500)',
              color: 'var(--color-text-main, #334155)',
              display: 'inline-block'
            }}
          >
            {skill}
          </span>
        ))}
      </div>
    );
  }

  // 2. Badge Grid Layout (Structured colored badge squares)
  if (variant === 'skills-badge-grid') {
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
        {flatSkills.map((skill, idx) => (
          <span 
            key={idx} 
            style={{ 
              padding: '6px 12px', 
              backgroundColor: 'var(--color-bg-page, #FFFFFF)', 
              border: '1px solid var(--color-border, #E2E8F0)',
              borderRadius: '4px',
              fontSize: 'var(--font-size-body, 9pt)',
              color: 'var(--color-primary, #16324F)',
              fontWeight: '600'
            }}
          >
            {skill}
          </span>
        ))}
      </div>
    );
  }

  // 3. Categorized / Sidebar Stack Layouts
  if (hasCategories && (variant === 'skills-categorized' || variant === 'skills-sidebar')) {
    const isSidebar = variant === 'skills-sidebar';
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: isSidebar ? '8px' : '12px' }}>
        {Object.entries(categories).map(([catName, list], idx) => (
          <div 
            key={idx} 
            className="skills-category-block"
            style={{ 
              fontSize: 'var(--font-size-body, 9pt)', 
              lineHeight: 1.45,
              color: 'var(--color-text-main)' 
            }}
          >
            <div 
              style={{ 
                color: 'var(--color-primary)', 
                textTransform: 'uppercase', 
                fontSize: 'var(--font-size-label, 8pt)', 
                fontWeight: 700,
                letterSpacing: '0.08em', 
                marginBottom: '4px'
              }}
            >
              {catName}
            </div>
            <div style={{ color: 'var(--color-text-main)' }}>
              {list.join(', ')}
            </div>
          </div>
        ))}
      </div>
    );
  }

  // 4. Simple List (Comma-separated line)
  return (
    <div style={{ fontSize: 'var(--font-size-body, 9pt)', color: 'var(--color-text-main)', lineHeight: 1.5 }}>
      {flatSkills.join(', ')}
    </div>
  );
};
export default SkillsBlock;
